import * as React from 'react';

import { IBefugnis } from '../../models/ApiTypes';

const Befugnis: React.StatelessComponent<{
  befugnis: IBefugnis
}> = (props) => {
  let status;
  if (props.befugnis.gueltig) {
    status = <span className="text-success">{(props.befugnis.ablaufdatum) ? `gültig bis ${props.befugnis.ablaufdatum}` : 'unbefristet'}</span>;
  } else {
    status = <span className="text-danger">{`abgelaufen seit ${props.befugnis.ablaufdatum}`}</span>;
  }

  return (
    <div>
      {props.befugnis.kuerzel} - {status}
    </div>
  );
};

export default Befugnis;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/user/Befugnis.tsx